import React from 'react';

import { withBemMod } from '@bem-react/core';

import type { IconProps as LegoIconProps } from '../../Icon';
import { cnIcon } from '../../Icon';

import '../../Icon/_glyph/Icon_glyph.css';

interface HrIconProps {
    glyph?: 'type-tick';
    sizeManagement?: 'self' | 'parent';
}

export const withGlyphTypeTick = withBemMod<HrIconProps, LegoIconProps>(
    cnIcon(),
    {
        glyph: 'type-tick',
    },
    (Icon) =>
        ({ className, sizeManagement = 'self', ...props }) => {
            return (
                <Icon
                    {...props}
                    className={cnIcon({ hasGlyph: 'noFill', sizeManagement }, [className])}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                    >
                        <path
                            d="M14.3213 6.26564C14.727 5.89117 15.3598 5.91591 15.7344 6.3213C16.1089 6.72697 16.0842 7.35973 15.6788 7.73439L9.17876 13.7344C8.78436 14.0984 8.17254 14.0866 7.79302 13.707L4.29302 10.207C3.90249 9.81652 3.90249 9.1835 4.29302 8.79298C4.65913 8.42686 5.23813 8.40427 5.63091 8.72462L5.70708 8.79298L8.52739 11.6133L14.3213 6.26564Z"
                            fill="currentColor"
                        />
                    </svg>
                </Icon>
            );
        },
);
